export default {
  app_name: 'UpMobil +',
  categoriesList: 'Categories',
  labelsList: 'Labels',
  treeList: 'Tree'
}
